var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 846 1010",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M700.226 0L408.973 842.215L192.973 221.873H50.823L332.336 1010H483.751L845.927 0H700.226Z",
          fill: _vm.fill,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M135.804 67.903C135.804 30.384 105.387 0 67.901 0C30.415 0 0 30.385 0 67.903C0 105.389 30.415 135.774 67.901 135.774C105.386 135.774 135.804 105.389 135.804 67.903Z",
          fill: _vm.fill,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }